__turbopack_context__.v({
  "basicDetails": "NgXxiG_basicDetails",
  "blur": "NgXxiG_blur",
  "blurredIconWrapper": "NgXxiG_blurredIconWrapper",
  "blurredInfoWrapper": "NgXxiG_blurredInfoWrapper",
  "buttonWrapper": "NgXxiG_buttonWrapper",
  "collapseWrapper": "NgXxiG_collapseWrapper",
  "favIconWrapper": "NgXxiG_favIconWrapper",
  "globalWrapper": "NgXxiG_globalWrapper",
  "grammar": "NgXxiG_grammar",
  "grammarWrapper": "NgXxiG_grammarWrapper",
  "imageWrapper": "NgXxiG_imageWrapper",
  "madeBy": "NgXxiG_madeBy",
  "maxPerSpecialOfferWrapper": "NgXxiG_maxPerSpecialOfferWrapper",
  "name": "NgXxiG_name",
  "pricePerGrammar": "NgXxiG_pricePerGrammar",
  "productDescription": "NgXxiG_productDescription",
  "rightAddToFavouritesButton": "NgXxiG_rightAddToFavouritesButton",
  "specialPromotionWrapper": "NgXxiG_specialPromotionWrapper",
  "styledImage": "NgXxiG_styledImage",
  "tagsWrapper": "NgXxiG_tagsWrapper",
  "wrapper": "NgXxiG_wrapper",
});
